import React from 'react';

import EventUsersBadge from 'legacy/common/components/wysiwyg-form/EventUsersBadge';

const GuestlistBadges = ({ onClick, guestsPreview, totalGuests }) => (
  <div className="mt-6">
    <EventUsersBadge
      additionalGuests={Math.max(totalGuests - guestsPreview.length, 0)}
      onClick={onClick}
      title="Guest List"
      data={guestsPreview}
      secondaryDefaultText={
        totalGuests === 0 ? 'Be the first to RSVP!' : `${totalGuests} Total`
      }
    />
  </div>
);

export default GuestlistBadges;
